var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:verified"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.73281 22.7871L6.83281 19.5871L3.23281 18.7871L3.58281 15.0871L1.13281 12.2871L3.58281 9.48711L3.23281 5.78711L6.83281 4.98711L8.73281 1.78711L12.1328 3.23711L15.5328 1.78711L17.4328 4.98711L21.0328 5.78711L20.6828 9.48711L23.1328 12.2871L20.6828 15.0871L21.0328 18.7871L17.4328 19.5871L15.5328 22.7871L12.1328 21.3371L8.73281 22.7871ZM11.0828 15.8371L16.7328 10.1871L15.3328 8.73711L11.0828 12.9871L8.93281 10.8871L7.53281 12.2871L11.0828 15.8371Z",
    fill: "#238ECA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/blue_tick.dc1cd9e809953b73bad04d14931e6319.svg";
export { ForwardRef as ReactComponent };